import { PublicClientApplication, type Configuration } from '@azure/msal-browser';
import { env } from '../config/env';

// "common" — same multi-tenant + personal-account authority the mobile app uses
// (app/services/firebaseAuth.ts's MS_DISCOVERY). The backend's exchangeMicrosoftToken()
// accepts any of common/organizations/consumers as the token issuer, so this must stay in
// sync with that allowlist (auth.service.ts's MICROSOFT_PUBLIC_TENANTS).
const msalConfig: Configuration = {
  auth: {
    clientId: env.microsoftClientId ?? '',
    authority: 'https://login.microsoftonline.com/common',
    // MSAL requires this origin to be registered as a "Single-page application" redirect
    // URI on the Azure AD app registration — see .env.example.
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
  },
};

let msalInstance: PublicClientApplication | null = null;
let initPromise: Promise<PublicClientApplication> | null = null;

// Lazily constructed/initialized — only ever needed once someone clicks "Sign in with
// Microsoft", and env.microsoftClientId may be unset (feature hides itself; see Login.tsx).
export async function getMsalInstance(): Promise<PublicClientApplication> {
  if (!env.microsoftClientId) {
    throw new Error('Microsoft sign-in is not configured.');
  }
  if (!msalInstance) {
    msalInstance = new PublicClientApplication(msalConfig);
  }
  if (!initPromise) {
    initPromise = msalInstance.initialize().then(() => msalInstance!);
  }
  return initPromise;
}
